import { executeGetAcknowledgePrescreen } from 'actions/user.actions';
import { useDispatch } from 'react-redux';
import { useLogger } from 'hook/error.hook';
import { useEffect } from 'react';
import {
  setAcknowledgePrescreen,
  getAcknowledgePrescreen,
} from 'helpers/localstorage';
import { useConfig } from './config.hook';

export const useAcknowledgePrescreen = ({
  awaitExecution = true,
  isOcf = false,
}) => {
  const logger = useLogger({
    name: 'acknowledgePrescreen.hook',
  });

  const dispatch = useDispatch();
  const { config } = useConfig();

  useEffect(() => {
    if (awaitExecution === false) {
      executeAcknowledgePrescreen();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [awaitExecution]);

  const executeAcknowledgePrescreen = () => {
    const enableCallAcknowledgePrescreen =
      !isOcf && getAcknowledgePrescreen() === 'true';

    if (enableCallAcknowledgePrescreen || !config?.executeAcknowledgePrescreen)
      return;

    dispatch(executeGetAcknowledgePrescreen())
      .then(() => {
        if (!isOcf) setAcknowledgePrescreen(true);
      })
      .catch(err => {
        logger.reportAPIError(err);
      });
  };

  return { executeAcknowledgePrescreen };
};
